import { Component, Input, OnInit } from '@angular/core';
import { GroupClassDetailsModel } from '@bayclubs/group-classes-employee-api';
import { gcManagementEnumerations } from '../../../../interfaces/interfaces.module';

@Component({
    selector: '[app-group-classes-details-basics]',
    templateUrl: './group-classes-details-basics.component.html',
    styleUrls: ['./group-classes-details-basics.component.scss'],
    standalone: false
})
export class GroupClassesDetailsBasicsComponent implements OnInit {
    @Input()
    public model: GroupClassDetailsModel;

    constructor() {}

    ngOnInit() {

    }

    public isActive(): boolean {
        return this.model.status.code === gcManagementEnumerations.GroupClassStatus.active.code;
    }

    public get showRevenueDepartment(): boolean {
        return !!this.model.revenueDepartment;
    }

    public get canShowAttendance(): boolean {
        return this.isActive && !this.model.classOnline.isOnline;
    }

    public get isBookingWindowValueIsPlural(): boolean {
        return this.model.bookingWindowValue > 1;
    }

    public get isBookingWindowUnitIsDays(): boolean {
        return this.model.bookingWindowUnit.code === gcManagementEnumerations.GroupClassBookingWindowUnit.days.code;
    }

    public get isVisibleToConnect(): boolean {
        return this.model.isVisibleToConnect;
    }

    public get isBookingWindowApplicable(): boolean {
        return this.model.isBookingWindowApplicable;
    }

    public get isRecurring(): boolean {
        return this.model.isRecurring;
    }

    public get isOnline(): boolean {
        return this.model.classOnline.isOnline;
    }

    public get isStreamingServiceDefined(): boolean {
        if (this.model.classOnline.streamingService) {
            return true;
        }
        return false;
    }
}
